export default __webpack_public_path__ + "static/media/image.conscientai.b2f88568.png";